var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcBubbleArrowDown = function SvgIcBubbleArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M5.272 9.038c.772 1.323 2.684 1.323 3.456 0L14 0H0z"
  })));
};
export default SvgIcBubbleArrowDown;